import Clear from './../layouts/Clear.vue';

export default {
  path: '/clients',
  component: Clear,
  children: [
    {
      path: '',
      name: 'clients.index',
      component: () => import('@/views/clients/index.vue'),
    },
    {
      path: 'report/:code',
      name: 'clients.report',
      component: () => import('@/views/clients/clientReport.vue'),
      props: true,
      meta: {title: 'Relatório do usuário'}
  },
  ],
};
